// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__sBQwi","requiredAsterisk":"Info_requiredAsterisk__2AJCW"};